module.exports = __webpack_public_path__ + "img/eye.be1f9d5a.svg";